"use client";


import { seasonHex } from "./podcast-cover";

export function PodcastLogoTile({
  size,
  seasonNumber,
  playing = false,
}: {
  size: "sm" | "md";
  seasonNumber: number | null;
  playing?: boolean;
}) {
  const sizeClass =
    size === "sm" ? "size-12 rounded-[10px]" : "size-14 rounded-[14px]";
  const logoHeightClass = size === "sm" ? "h-7" : "h-9";
  return (
    <div
      style={{ background: seasonHex(seasonNumber) }}
      className={`${sizeClass} relative flex shrink-0 items-center justify-center overflow-hidden`}
    >
      {playing && <PulsingRings />}
      <span
        aria-hidden
        className={`${logoHeightClass} aspect-291/460 relative bg-white`}
        style={{
          maskImage: "url(/assets/logo/padcast-logo.svg)",
          WebkitMaskImage: "url(/assets/logo/padcast-logo.svg)",
          maskSize: "contain",
          WebkitMaskSize: "contain",
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskPosition: "center",
          WebkitMaskPosition: "center",
        }}
      />
    </div>
  );
}

function PulsingRings() {
  return (
    <>
      <svg
        viewBox="0 0 48 48"
        aria-hidden
        className="absolute inset-0 size-full"
        preserveAspectRatio="xMidYMid meet"
      >
        <g fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="1">
          {[10, 16].map((r, i) => (
            <circle
              key={r}
              cx="24"
              cy="24"
              r={r}
              style={{
                transformOrigin: "24px 24px",
                animation: `mini-player-ring 1.8s ease-in-out infinite ${i * 0.3}s`,
              }}
            />
          ))}
        </g>
      </svg>
      <style jsx global>{`
        @keyframes mini-player-ring {
          0%,
          100% {
            stroke-opacity: 0.15;
            transform: scale(0.9);
          }
          50% {
            stroke-opacity: 0.6;
            transform: scale(1.05);
          }
        }
      `}</style>
    </>
  );
}
